export default function setUnit({ state, props, storage }) {
  const value = storage.get('app')
  state.set('basket.unit', props.unit)
  let obj = {
    ...value,
    unit: props.unit
  }

  storage.set('app', obj)
}



// WEBPACK FOOTER //
// ./src/modules/Basket/actions/setUnit.js